import { render, staticRenderFns } from "./BasePasswordInput.vue?vue&type=template&id=54232cd2&scoped=true&"
import script from "./BasePasswordInput.vue?vue&type=script&lang=js&"
export * from "./BasePasswordInput.vue?vue&type=script&lang=js&"
import style0 from "./BasePasswordInput.vue?vue&type=style&index=0&id=54232cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54232cd2",
  null
  
)

export default component.exports